/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { Auth } from 'app/scripts/db/Auth';
import { getKey, Key } from '@trello/keybindings';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { maybeDisplayLimitsErrorOnCardAdd } from 'app/scripts/views/card/CardLimitsError';
import { l } from 'app/scripts/lib/localize';
import { LabelLimitsErrorView } from 'app/scripts/views/label/LabelLimitsErrorView';
import { SelectCardPosition } from 'app/scripts/views/card/SelectCardPosition';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
const { View } = require('app/scripts/views/internal/view');
const { templates } = require('app/scripts/views/internal/templates');
import { Analytics } from '@trello/atlassian-analytics';
import _ from 'underscore';
class CardCopyView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'copy card';

    this.prototype.showCurrentPosition = true;

    this.prototype.events = {
      'change .js-select-position': 'renderValues',
      'change .js-select-list': 'updatePositionList',
      'change .js-select-board': 'updateBoardData',

      'keydown textarea[name="name"]': 'keydownEvent',
      'click .js-submit': 'submit',
      'submit form': 'submit',
    };
  }

  // TODO: create TypeScript type for `opts`
  // @ts-expect-error Parameter 'opts' implicitly has an 'any' type.
  initialize(opts) {
    Analytics.sendScreenEvent({
      name: 'copyCardInlineDialog',
      containers: this.model.getAnalyticsContainers(),
      attributes: {
        cardIsTemplate: this.model.get('isTemplate'),
        cardIsClosed: this.model.get('closed'),
      },
    });
    return (this.onCopy = opts.onCopy != null ? opts.onCopy : function () {});
  }

  render() {
    const data = this.model.toJSON();
    data.numChecklists = this.model.checklistList.length;
    data.numCustomFields = this.model.customFieldItemList.length;
    data.numMembers = data.idMembers.length;
    data.numLabels =
      (data.idLabels != null ? data.idLabels.length : undefined) != null
        ? data.idLabels != null
          ? data.idLabels.length
          : undefined
        : 0;
    data.numAttachments = data.badges.attachments;
    data.numComments = data.badges.comments;
    data.numStickers = data.stickers.length;

    data.hasChecklists = data.numChecklists > 0;
    data.hasMembers = data.idMembers.length > 0;
    data.hasLabels = data.numLabels > 0;
    data.hasAttachments = data.badges.attachments > 0;
    data.hasStickers = data.stickers.length > 0;
    data.hasCustomFields = data.numCustomFields > 0;

    // Don't show option to copy comments hidden on templates
    data.hasComments =
      data.badges.comments > 0 && !this.model.getBoard().isTemplate();

    data.hasStuff =
      data.hasChecklists ||
      data.hasMembers ||
      data.hasLabels ||
      data.hasAttachments ||
      data.hasComments ||
      data.hasStickers ||
      data.hasCustomFields;

    data.loading = this.loading;

    let currentBoard = this.model.getBoard();
    const enterprise = currentBoard.getEnterprise();

    // `attributes` is the only method of `userInfo` used in this view, but there are many more properties
    // TODO: Create complete type for Auth.me() return value
    // @ts-expect-error Member 'attributes' implicitly has an 'any' type.
    const userInfo: { attributes? } = Auth.me();

    const isBoardEnterpriseOwned = currentBoard.isEnterpriseBoard();

    if (isBoardEnterpriseOwned) {
      const boardEnterpriseId = currentBoard.get('idEnterprise');
      const userEnterprises = userInfo.attributes?.enterpriseLicenses;
      const isUserOwnedBySameEnterpriseAsBoard =
        userEnterprises?.some(
          // @ts-expect-error Parameter 'userEnterprise' implicitly has an 'any' type.
          (userEnterprise) => userEnterprise.idEnterprise === boardEnterpriseId,
        ) || false;

      data.isCopy = true;
      data.hasEnterprise = true;
      data.enterpriseName = enterprise?.get('displayName');

      if (isUserOwnedBySameEnterpriseAsBoard) {
        // allow user to copy cards to other boards in the enterprise
        currentBoard =
          this.model.getBoard().getMembershipFor(Auth.me()) == null
            ? currentBoard
            : null;
        data.organizations = Auth.me().getOpenBoardsInEnterpriseByOrg(
          true,
          enterprise?.get('id'),
          currentBoard,
        );
      } else {
        // only allow the user to copy cards to the same board
        data.restrictToCurrentBoard = true;
        data.organizations = [
          {
            displayName:
              currentBoard.getOrganization()?.get('displayName') ||
              l('member boards.boards'),
            boards: [_.extend(currentBoard.toJSON(), { selected: true })],
          },
        ];
      }
    } else {
      currentBoard = this.model
        .getBoard()
        .isEditableByTeamMemberAndIsNotABoardMember()
        ? currentBoard
        : null;
      data.organizations = Auth.me().getOpenBoardsByOrg(true, currentBoard);
    }

    for (const org of data.organizations) {
      for (const board of org.boards) {
        if (board.id === this.model.get('idBoard')) {
          board.selected = true;
        }
      }
    }

    const partials = { move_card_controls: templates.move_card_controls };

    this.$el.html(
      templates.fill(
        require('app/scripts/views/templates/card_copy'),
        data,
        { editable: this.model.editable() },
        partials,
      ),
    );

    this.updateBoardData();

    return this;
  }

  getData() {
    this.loading = true;

    return Promise.all([
      ModelLoader.loadCardCopyData(this.model.get('idBoard'), this.model.id),
      ModelLoader.loadBoardMinimal(this.model.get('idBoard')),
    ]).finally(() => {
      this.loading = false;
      return this.render();
    });
  }

  keydownEvent(e: KeyboardEvent) {
    if (getKey(e) === Key.Enter) {
      stopPropagationAndPreventDefault(e);
      this.submit(e);
      return;
    }
  }

  submit(e: Event) {
    stopPropagationAndPreventDefault(e);

    const nameInput = $('textarea[name="name"]', this.$el);

    // return if the user hasn't entered a title
    if ((nameInput.val() as string).trim() === '') {
      nameInput.focus().select();
      return;
    }

    const idListSelected = $('.js-select-list', this.$el)
      .find('option:selected')
      .val();
    const idBoardSelected = $('.js-select-board', this.$el)
      .find('option:selected')
      .val();
    const boardSelected = this.modelCache.get('Board', idBoardSelected);
    const listSelected =
      boardSelected != null
        ? boardSelected.listList.get(idListSelected)
        : undefined;
    const options = {
      $elem: $(e.target as HTMLElement),
      hasChecklists: this.model.checklistList.length > 0,
      hasAttachments: this.model.attachmentList.length > 0,
      destinationBoard: boardSelected,
      destinationList: listSelected,
    };
    if (maybeDisplayLimitsErrorOnCardAdd(options)) {
      return;
    }

    const mandatoryFieldsToKeep = ['start', 'due'];
    const optionalFieldsToKeep = $('input:checkbox:checked', this.$el)
      .get()
      // @ts-expect-error
      .map((checkbox: HTMLInputElement) => checkbox.name);
    const fieldsToKeep = mandatoryFieldsToKeep.concat(optionalFieldsToKeep);

    if (idBoardSelected !== this.model.getBoard().id) {
      const hasLabels =
        this.model.getLabels().length > 0 && _.contains(fieldsToKeep, 'labels');
      if (hasLabels && boardSelected.isOverLimit('labels', 'perBoard')) {
        PopOver.pushView(new LabelLimitsErrorView());
        return;
      }
    }

    // prevent card copy spamming
    $('.js-submit', this.$el).attr('disabled', 'disabled');

    const traceId = Analytics.startTask({
      taskName: 'create-card/copy',
      source: this.options.source || 'copyCardInlineDialog',
    });

    this.model
      .copyTo({
        name: (nameInput.val() as string).trim(),
        idList: idListSelected,
        pos: $('.js-select-position', this.$el).find('option:selected').val(),
        keepFromSource: fieldsToKeep,
        traceId,
      })
      .then(() => {
        PopOver.hide();
        this.onCopy();

        Analytics.sendTrackEvent({
          action: 'copied',
          actionSubject: 'card',
          source: 'copyCardInlineDialog',
          containers: {
            card: {
              id: this.model.id,
            },
            board: {
              id: this.model.getBoard().id,
            },
          },
          attributes: {
            isCardTemplate: !!this.model.get('isTemplate'),
            isBoardTemplate: this.model.getBoard().isTemplate(),
            taskId: traceId,
          },
        });

        Analytics.taskSucceeded({
          taskName: 'create-card/copy',
          source: this.options.source || 'copyCardInlineDialog',
          traceId,
        });
      })
      .catch((error: Error) => {
        PopOver.hide();
        Alerts.flash('could not copy card', 'error', 'card-copy');

        Analytics.sendOperationalEvent({
          action: 'failed',
          actionSubject: 'cardCopy',
          source: 'copyCardInlineDialog',
          containers: {
            card: {
              id: this.model.id,
            },
            board: {
              id: this.model.getBoard().id,
            },
          },
          attributes: {
            isCardTemplate: !!this.model.get('isTemplate'),
            isBoardTemplate: this.model.getBoard().isTemplate(),
            taskId: traceId,
          },
        });

        Analytics.taskFailed({
          taskName: 'create-card/copy',
          traceId,
          source: this.options.source || 'copyCardInlineDialog',
          error,
        });
      });
  }
}
CardCopyView.initClass();

_.extend(CardCopyView.prototype, SelectCardPosition);

export { CardCopyView };
